//#region Dependencias
import React, { Component } from 'react';
import '../css/dataTables.css';
import $ from 'jquery';
//#endregion

class MultipleCountersModal extends Component {
    //#region Acciones del componente
    constructor(props) {
        super(props);
        this.state = {
            counterType: "12",
        }
    }

    closeModal = async () => {
        $("#multipleCountersModal").modal("hide");
    };
    //#endregion

    //#region Render
    render() {
        const { counters, type, writeMode, openSelectCounter, removeCounter, saveCounters } = this.props;
        const { counterType } = this.state;

        return (
            <div class="modal fade no-select" id="multipleCountersModal" tabindex="-1" role="dialog" aria-labelledby="multipleCountersModalTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header modal-style">
                            <h5 class="modal-title" id="multipleCountersModalTitle"> {`Encargados de recuento ${type}`} </h5>
                            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                        <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table table-scroll response" style={{marginBottom: 0}}>
                                                <div
                                                    className="w-100 tab-pane fade show active "
                                                    id="dataContenido"
                                                    aria-labelledby="nav-home-tab-Contenido"
                                                    style={{minHeight: 350, maxHeight: 400}}>
                                                    <table
                                                        id="dataTableDocuments"
                                                        className="display"
                                                        style={{width: '100%', marginBottom: 40, marginRight: -2000}}>
                                                        <thead className="table-header-yellow">
                                                            <tr className="sticky-header" style={{ textAlign: "center", backgroundColor: '#d2ab24' }}>
                                                                <td className="sticky-column" style={{ backgroundColor: '#d2ab24' }}> # </td>
                                                                <td> Tipo </td>
                                                                <td> Nombre </td>
                                                                {/* Acción Eliminar */}
                                                                {!!writeMode && counters.length > 1 && <td className="sticky-columns" style={{ backgroundColor: '#d2ab24' }} />}
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {counters.map((counter, index) => {
                                                                return (
                                                                    <tr>
                                                                        <td className="sticky-column text-center" style={{ backgroundColor: '#FFF' }}> {index + 1} </td>
                                                                        <td> {Number(counter.CounterType) === 12 ? "Usuario" : "Empleado"} </td>
                                                                        <td> {counter.CounterName} </td>
                                                                        {/* Acción Eliminar */}
                                                                        {!!writeMode && counters.length > 1 &&
                                                                            <td className="sticky-columns">
                                                                                <div className='input-group'>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn btn-outline-danger"
                                                                                        onClick={() => removeCounter(index)}>
                                                                                        <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                                                    </button>                                                                        
                                                                                </div>
                                                                            </td>
                                                                        }
                                                                    </tr>
                                                                );
                                                            })}

                                                            {!!writeMode && 
                                                                <tr>
                                                                    <td className="sticky-column text-center" colSpan={2} style={{backgroundColor: '#FFF'}}>
                                                                        <div className='input-group'>
                                                                            <select
                                                                                id='inputCountType'
                                                                                className="form-control"
                                                                                value={counterType || "12"}
                                                                                onChange={(ev) => {this.setState({counterType: ev.target.value})}}>
                                                                                <option value="12">Usuario</option>
                                                                                <option value="171">Empleado</option>
                                                                            </select>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn btn-outline-success"
                                                                                onClick={() => openSelectCounter(counterType)}>
                                                                                <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                                            </button>                                                                        
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            {!!writeMode &&  <button className="btn botonCorrect" onClick={saveCounters}> Guardar </button> }
                            <button className="btn botonCerrar text-white" data-dismiss="modal">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    //#endregion
}

export default MultipleCountersModal;